import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, Stepper, Step, StepLabel, Checkbox, CircularProgress, Card, CardContent, Typography, IconButton, CardMedia, CardActionArea, Popover, RadioGroup, FormControlLabel } from '@mui/material';
import { useAppDispatch, useAppSelector } from "src/app/react/hooks/redux";
import { useStateCallback } from "src/app/react/hooks/useStateCallback";
import { Auth } from "src/app/models/auth";
import { getGroups, getProductsOfGroup } from 'src/app/react/redux/group/actions';
import { getFirstLetterFromWords, truncateString } from '../../../shared/utils';
import { GroupCard, GroupName } from './style';
import { GroupResponse } from 'src/app/react/models/group/group-response.model';
import RadioButton from 'antd/lib/radio/radioButton';
interface GroupsPurchaseProps {
    selectedGroup: (selectedGroup: number) => void;
}

export const GroupsPurchase = ({ selectedGroup }: GroupsPurchaseProps) => {
    
    const dispatch = useAppDispatch();
    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));

    const { groups, products, error, loading } = useAppSelector(state => state.group);    
    const [ selectedGroupRadio, setSelectedGroupRadio ] = useState(null)

    useEffect(() => {
        if(groups.length <= 0)
            dispatch(getGroups(currentUser.token.assignorGuid));
    },[]);

    const handleChange = (index: any) => {
        setSelectedGroupRadio(index);
        selectedGroup(groups[index].groupId);
        dispatch(getProductsOfGroup(groups[index].groupId, currentUser.token.assignorGuid));
    }

    return (
        <>
            <Container disableGutters maxWidth={false}>                
                <Typography variant="h6">Grupos</Typography>
                <Typography variant="subtitle1" >Selecione um grupo</Typography>
                {loading &&
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Box sx={{textAlign: 'center'}}>
                                <CircularProgress />
                            </Box>
                        </Grid>
                    </Grid>
                }
                {!loading &&
                    <Grid container spacing={{ xs: 2, md: 2 }}  columns={{ xs: 12, sm: 12, md: 12 }}>
                        {groups.map((group: GroupResponse, index: any) => (
                            <Grid item xs={6} sm={6} md={4} lg={3} xl={2} key={index}>
                                <GroupCard selected={selectedGroupRadio === index} elevation={0}>      
                                    <CardActionArea sx={{ display: 'flex', justifyContent: 'flex-start'}} onClick={() => handleChange(index)}>                                               
                                        <GroupName selected={selectedGroupRadio === index}>
                                            { getFirstLetterFromWords(group.groupName, 2).toUpperCase()}     
                                        </GroupName>                                     
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <CardContent sx={{ flex: '1 0 auto' }}>
                                                <Typography component="div" variant="body1" sx={{fontWeight: '500'}}>
                                                    {truncateString(group.groupName, 3)}
                                                </Typography>                                               
                                                <Typography variant="subtitle2" sx={{fontWeight: '400'}} component="div">
                                                    {group.totalCollaborators + ' Favorecidos'}
                                                </Typography>
                                            </CardContent>
                                        </Box>
                                    </CardActionArea>                                  
                                </GroupCard>
                            </Grid>                            
                        ))}
                    </Grid>
                }
            </Container>
        </>
    );
}
